import { Injectable } from '@angular/core';
import { CryptoHashService } from './crypto-hash.service';

@Injectable()
export class BrowserCryptoHashService extends CryptoHashService {
  sha1 = this.create('SHA-1');
  sha256 = this.create('SHA-256');
  sha384 = this.create('SHA-384');
  sha512 = this.create('SHA-512');

  constructor() {
    super();
  }

  private bufferToHex(buffer: ArrayBufferLike) {
    const view = new DataView(buffer);

    let hexCodes = '';
    for (let index = 0; index < view.byteLength; index += 4) {
      hexCodes += view.getUint32(index).toString(16).padStart(8, '0');
    }

    return hexCodes;
  }
  private create(algorithm: string) {
    return async (buffer: any, { outputFormat = 'hex' } = {}) => {
      if (typeof buffer === 'string') {
        buffer = new globalThis.TextEncoder().encode(buffer);
      }

      const hash = await globalThis.crypto.subtle.digest(algorithm, buffer);

      return outputFormat === 'hex' ? this.bufferToHex(hash) : (hash as any);
    };
  }
}
